module.exports = __webpack_public_path__ + "static/media/005-Wechseln_ID_21.3f99c258.mp3";